import { Dispatch, SetStateAction, useCallback } from 'react';
import { useToast } from '@shared/components/toast';
import { useUpdateViewTemplate } from '@shared/scenes/workflows/hooks';
import { i18n } from '@shared/util/i18n';

export function useSaveViewTemplate(
  workflowTemplateId: string,
  setViewTemplate: Dispatch<SetStateAction<MBAPI.ViewTemplate>>,
): () => Promise<void> {
  const updateViewTemplate = useUpdateViewTemplate(workflowTemplateId);
  const toast = useToast();

  return useCallback(async () => {
    const save = async (viewTemplate: MBAPI.ViewTemplate) => {
      try {
        await updateViewTemplate({ ...viewTemplate, defaultReadonlyComponents: true });
        toast.show({
          icon: 'check-filled',
          message: i18n('card.actions.save.saveForEveryone.success'),
        });
      } catch (error) {
        toast.show({
          style: 'warning',
          message: i18n('errors.somethingWentWrong'),
        });
      }
    };

    // accessing current viewTemplate via state-setter, so this callback can be
    // stateless and not change every time viewTemplate changes
    setViewTemplate(viewTemplate => {
      save(viewTemplate);
      return viewTemplate;
    });
  }, [updateViewTemplate, setViewTemplate, toast]);
}
